import type { TaxRebate } from '../../types/tax';

export const TAX_REBATES_2025_26: TaxRebate = {
  primary: 17235,    // Under 65 years
  secondary: 9444,   // 65 years and older
  tertiary: 3145     // 75 years and older
};